import CurrencyAustralianDollarlingIcon from '@/refactor/assets/currencies/AUD.svg'
import CurrencyEuroIcon from '@/refactor/assets/currencies/EUR.svg'
import CurrencyPoundSterlingIcon from '@/refactor/assets/currencies/GBP.svg'
import CurrencyIsraeliNewShekelIcon from '@/refactor/assets/currencies/ILS.svg'
import CurrencySwedishKronaIcon from '@/refactor/assets/currencies/SEK.svg'
import CurrencyDollarIcon from '@/refactor/assets/currencies/USD.svg'
import { UserCurrency } from '@/types/common'

export const CurrencyIcons: Record<UserCurrency, string> = {
	[UserCurrency.USD]: CurrencyDollarIcon,
	[UserCurrency.EUR]: CurrencyEuroIcon,
	[UserCurrency.GBP]: CurrencyPoundSterlingIcon,
	[UserCurrency.AUD]: CurrencyAustralianDollarlingIcon,
	[UserCurrency.SEK]: CurrencySwedishKronaIcon,
	[UserCurrency.ILS]: CurrencyIsraeliNewShekelIcon,
}
